import { Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { observer } from "mobx-react";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import NewOrEditAddress from "@/common-components-src/js/address/addressCreate";
import PAGE_TYPE from "@/common-components-src/js/address/const/pageType";

interface addressAddProps {
  closeHandler: () => void;
  newCreateSaveClose: () => void;
}

const addressAdd: React.FC<addressAddProps> = observer(({ closeHandler, newCreateSaveClose }) => {
  return (
    <UKDialog
      open={true}
      onClose={closeHandler}
      showCloseBtn={true}
      sx={{
        "& .MuiDialog-paper": {
          width: "880px", // 设置自定义宽度
          Height: "596px",
          // padding: "0px",
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={closeHandler}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <Typography sx={{ p: 2, padding: 0 }}>
        <NewOrEditAddress handleClose={newCreateSaveClose} isAfterSales={true} isModal={true} pageType={PAGE_TYPE.BILLING}/>
      </Typography>
    </UKDialog>
  );
});

export default addressAdd;
